import { arrayParamDeserializerHelper } from 'NewAngular/utils/urls';
export class FundChartUrlDeserializer {
}
// Do not try to parse the value for zoom because it can be '1' or '6m' and we don't want the '1' to be parsed
// as an int.
FundChartUrlDeserializer.zoom = (urlValue) => urlValue.toString();
// Fund chart title and note should always be a string. Without this override, titles including ',' will be parsed
// as arrays by parseFlattenedObject
FundChartUrlDeserializer.title = (urlValue) => urlValue.toString();
FundChartUrlDeserializer.note = (urlValue) => urlValue.toString();
FundChartUrlDeserializer.securities = (urlValue) => arrayParamDeserializerHelper(urlValue);
FundChartUrlDeserializer.calcs = (urlValue) => arrayParamDeserializerHelper(urlValue);
FundChartUrlDeserializer.chartAnnotations = (urlValue) => arrayParamDeserializerHelper(urlValue);
FundChartUrlDeserializer.aiSummaries = (urlValue) => arrayParamDeserializerHelper(urlValue);
